import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';

export class ErrorHandlers {
  static errorHandler(error: HttpErrorResponse): Observable<never> {
    console.error('error occurred!', error);
    return throwError(() => error);
  }

  static showErrorDialog(dialog: MatDialog, translate: TranslateService): void {
    dialog.open(ErrorDialogComponent, {
      data: {
        title: translate.instant('ERROR.DLG_ERROR_TITLE'),
        message: translate.instant('ERROR.CONNECTIONERROR')
      }
    });
  }
}
